import axios from 'axios'

const FRIEND = process.env.VUE_APP_FRIEND;

class FriendCalls {

  follow(profile, follower) {
    return axios.post(FRIEND + "follow/", { profile, follower })
    .then(response => response.data.follower);
  }

  unfollow(profile, follower) {
    return axios.post(FRIEND + "unfollow/", { profile, follower })
    .then(response => response.data.follower);
  }

  isFollowing(profile, follower) {
    return axios.get(FRIEND + `following/${profile}/${follower}`)
    .then(response => response.data.isFollowing);
  }

  isFollowingBack(profile, followers) {
    return axios.post(FRIEND + "following/back", { profile, followers })
    .then(response => response.data.followers);
  }

  followers(profile) {
    return axios.get(FRIEND + `followers/${profile}`)
    .then(response => response.data.followers);
  }

  following(profile) {
    return axios.get(FRIEND + `following/${profile}`)
    .then(response => response.data.following);
  }

  stats(profile) {
    return axios.get(FRIEND + `stats/${profile}`)
    .then(response => response.data.stats);
  }

}

const friendCalls = new FriendCalls();
export default friendCalls;
